var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 10.75V4.499C16.7501 4.42006 16.7345 4.34189 16.7043 4.26896C16.6741 4.19603 16.6298 4.12978 16.574 4.074L13.426 0.926C13.3136 0.813446 13.1611 0.75014 13.002 0.75H1.35C1.19087 0.75 1.03826 0.813214 0.925736 0.925736C0.813214 1.03826 0.75 1.19087 0.75 1.35V20.15C0.75 20.3091 0.813214 20.4617 0.925736 20.5743C1.03826 20.6868 1.19087 20.75 1.35 20.75H7.75M4.75 8.75H12.75M4.75 4.75H8.75M4.75 12.75H7.75M14.704 15.69L15.704 14.69C15.808 14.5857 15.9316 14.5029 16.0677 14.4465C16.2038 14.39 16.3497 14.3609 16.497 14.3609C16.6443 14.3609 16.7902 14.39 16.9263 14.4465C17.0624 14.5029 17.186 14.5857 17.29 14.69C17.3942 14.794 17.4768 14.9176 17.5332 15.0535C17.5896 15.1895 17.6186 15.3353 17.6186 15.4825C17.6186 15.6297 17.5896 15.7755 17.5332 15.9115C17.4768 16.0474 17.3942 16.171 17.29 16.275L16.29 17.275L14.704 15.689L11.713 18.68C11.5635 18.83 11.4654 19.0237 11.433 19.233L11.189 20.79L12.746 20.547C12.9553 20.5146 13.149 20.4165 13.299 20.267L16.289 17.275",
    stroke: "#58CC02",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.75V4.15C12.75 4.30913 12.8132 4.46174 12.9257 4.57426C13.0383 4.68679 13.1909 4.75 13.35 4.75H16.75",
    stroke: "#58CC02",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAdmin);
export default __webpack_public_path__ + "static/media/edit_admin.5ccd5c069f67e779556d640940d27549.svg";
export { ForwardRef as ReactComponent };